/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { PureComponent } from 'react';

import styles from './index.module.scss';

export default class ItemQuantityHandler extends PureComponent {
    render() {
        const { product, changeItemQuantity, readOnly } = this.props;
        const single = product.quantity === 1;

        return (
            <div
                className={`${styles.checkoutItemQuantityHandler}
                    ${readOnly ? styles['checkoutItemQuantityHandler--readOnly'] : ''}
                    ${!readOnly && single ? styles['checkoutItemQuantityHandler--moveLeft'] : ''}`}
            >
                {!readOnly && !!changeItemQuantity && (
                    <div
                        onClick={() => !single && changeItemQuantity(product.quantity - 1)}
                        className={`${styles.checkoutItemQuantityHandler__handler} ${
                            single ? styles['checkoutItemQuantityHandler__handler--hide'] : ''
                        }`}
                    >
                        -
                    </div>
                )}
                <div className={styles.checkoutItemQuantityHandler__amount}>{product.quantity}</div>
                {!readOnly && !!changeItemQuantity && (
                    <div
                        onClick={() => changeItemQuantity(product.quantity + 1)}
                        className={styles.checkoutItemQuantityHandler__handler}
                    >
                        +
                    </div>
                )}
            </div>
        );
    }
}
